import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet';
import AdminLayout from '../layout/AdminLayout';
import { useAuth } from '../../context/AuthContext';
import { getUserProfile, saveUserDataToStorage, saveUsersToStorage, updateMyPassword, updateMyPicture, updateProfile } from '../../models/UserModel';
import { capitalize, profilePic } from '../../helpers/GeneralHelper';
import dateFormat from "dateformat";
import { apiError } from '../../helpers/ErrorHelper';
import ProfileTabs from '../skeletons/ProfileTabs';
import { useNotificationCount } from '../../context/NotificationCountContext';
import { formatDate } from '../../helpers/DateHelper';

function Profile() {

  const { notificationCount, setNotificationCount } = useNotificationCount();  

  const { state, dispatch } = useAuth();
  const navigate = useNavigate();

  let user_data = state.user_data;

  const loader = document.getElementById('loading');

  //Update Profile Picture Start
  const [user_image, setUserImage] = useState('');
    
  const userImageFileRef = useRef(null);

  const handleUserImageClick = () => {
    userImageFileRef.current.click();
  }

  const handleUserImageChange = (event) => {
    const file = event.target.files[0];
    setUserImage(file);
  }

  const uploadProfilePicture = async() => {
    // Start the loading state
    loader.style.display = 'block';
    
    try {
        const formData = new FormData();
        formData.append('user_image', user_image);

        const response = await updateMyPicture(user_data.user_token, formData);

        if (response.status) {
            toast.success(response.message);

            setUserImage('');

            setProfileData(response.data.user_data);

            saveUserDataToStorage(response.data.user_data);

            saveUsersToStorage(response.data.users, response.data.pagination);

            dispatch({ type: 'UPDATE_USER_DATA', payload: { user_data: response.data.user_data } });

            setNotificationCount(localStorage.getItem('unread_notification_count'));
        }
        else{
            toast.error(response.message);
        }   
        
    } catch (error) {
        apiError(error);
    }

    // Stop the loading state
    loader.style.display = 'none';
  }
  //Update Profile Picture End


  // Get User Profile Start
  const [profileLoading, setProfileLoading] = useState(false);
  const [profileData, setProfileData] = useState([]);

  let { user_unique_id } = useParams();

  if (!user_unique_id) {
    user_unique_id = user_data.user_unique_id;
  }

  const fetchUserProfile = async () => {
    // Start the loading state
    setProfileLoading(true);

    try {
        let apiParam = {user_token: user_data.user_token, user_unique_id};
        const response = await getUserProfile(apiParam);

        if (typeof response != typeof undefined) {            
            setNotificationCount(localStorage.getItem('unread_notification_count'));
            setProfileData(response.user_data);
    
            // setUserFirstName(response.user_data.user_first_name);
            // setUserLastName(response.user_data.user_last_name);
            // setUserDob(new Date(response.user_data.user_dob));
            // setUserGender(response.user_data.user_gender);
            setUserEmail(response.user_data.user_email);
            setUserMobile(response.user_data.user_mobile);
            setUserAddress(response.user_data.user_address);

            // setDesignationId(response.user_data.user_designation_id);
            // setManagerId(response.user_data.user_manager_id);

            // let startDate = response.user_data.user_start_date && '0000-00-00' != response.user_data.user_start_date ? response.user_data.user_start_date : '';
            // setStartDate(startDate ? new Date(startDate) : null);

            // setUserRoleId(response.user_data.user_role_id);
            setProfileLoading(false);
        }
        else {
            navigate('/re-login');
        }    
        
    } catch (error) {
        console.error(error);
    }
  };  

  useEffect(() => {  
    fetchUserProfile();
  }, [user_unique_id]);
  // Get User Profile End

  // Get User Roles Start
//   const [userRoles, setUserRoles] = useState([]);
//   const [managers, setManagers] = useState([]);
//   const [designations, setDesignations] = useState([]);

//   useEffect(() => {
//     const fetchUserRoles = async() => {
//         try {
//             let apiParam = {user_token: user_data.user_token};
//             const response = await getUserRoles(apiParam);
    
//             if (typeof response != typeof undefined) {
//                 setUserRoles(response.user_roles);
    
//                 setNotificationCount(localStorage.getItem('unread_notification_count'));
//             }    
            
//         } catch (error) {
//             console.error(error);
//         }
//     }

//     const fetchManagers = async() => {
//         try {
//             let apiParam = {user_token: user_data.user_token};
//             const response = await getManagers(apiParam);
    
//             if (typeof response != typeof undefined) {
//                 setManagers(response.managers);
//             }    
//         } catch (error) {
//             console.error(error);
//         }
//     }

//     const fetchDesignations = async() => {
//         try {
//             let apiParam = {user_token: user_data.user_token};
//             const response = await getDesignations(apiParam);
    
//             if (typeof response != typeof undefined) {
//                 setDesignations(response.designations);
//             }
//         } catch (error) {
//             console.error(error);
//         }
//     }

//     fetchUserRoles();
//     fetchManagers();
//     fetchDesignations();
//   }, []);
  // Get User Roles End

  // Update General Info Start
//   const [user_first_name, setUserFirstName] = useState('');
//   const [user_last_name, setUserLastName] = useState('');
//   const [user_dob, setUserDob] = useState('');
//   const [user_gender, setUserGender] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userMobile, setUserMobile] = useState('');
  const [userAddress, setUserAddress] = useState('');
//   const [user_alternate_phone, setUserAlternatePhone] = useState('');
//   const [user_alternate_address, setUserAlternateAddress] = useState('');

//   const [designationId, setDesignationId] = useState('');
//   const [managerId, setManagerId] = useState('');
//   const [startDate, setStartDate] = useState('');

  const [genInfoerrors, setGenInfoErrors] = useState({user_email: '', user_mobile: '', user_address: ''});

  const updateGeneralInfo = async() => {
    // Start the loading state
    loader.style.display = 'block';

    try {
        // Clear previous errors
        setGenInfoErrors({});
    
        const formData = { user_email: userEmail, user_mobile: userMobile, user_address: userAddress };
        const response = await updateProfile(user_data.user_token, user_unique_id, formData);

        if (response.status) {
            toast.success(response.message);

            setProfileData(response.data.user_data);

            setNotificationCount(localStorage.getItem('unread_notification_count'));
        }
        else{
            setGenInfoErrors(response.error);
            toast.error(response.message);
        }     

    } catch (error) {
        apiError(error);
    }

    // Stop the loading state
    loader.style.display = 'none';
  };
  // Update General Info End

  // Update Account Info Start
//   const [user_role_id, setUserRoleId] = useState('');

//   const [accInfoErrors, setAccInfoErrors] = useState({user_role_id:  ''});

//   const updateAccountInfo = async() => {
//     // Start the loading state
//     loader.style.display = 'block';

//     try {
//         // Clear previous errors
//         setAccInfoErrors({});
    
//         const formData = { user_role_id };
  
//         const response = await updateUserAccountInfo(user_data.user_token, user_unique_id, formData);

//         if (response.status) {
//             toast.success(response.message);

//             setProfileData(response.data.user_data);

//             setNotificationCount(localStorage.getItem('unread_notification_count'));
//         }
//         else{
//             setAccInfoErrors(response.error);
//             toast.error(response.message);
//         }     

//     } catch (error) {
//         apiError(error);
//     }

//     // Stop the loading state
//     loader.style.display = 'none';
//   };
  // Update Account Info End


  // Change Password Start
  const [current_password, setCurrentPassword] = useState('');
  const [new_password, setNewPassword] = useState('');
  const [confirm_password, setConfirmPassword] = useState('');

  const [changePasswordErrors, setChangePasswordErrors] = useState({current_password:  '', new_password: '', confirm_password: ''});

  const changePassword = async() => {
    // Start the loading state
    loader.style.display = 'block';

    try {
        // Clear previous errors
        setChangePasswordErrors({});
    
        const formData = { current_password, new_password, confirm_password};
  
        const response = await updateMyPassword(user_data.user_token, formData);

        if (response.status) {
            toast.success(response.message);

            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');

            setNotificationCount(localStorage.getItem('unread_notification_count'));
        }
        else{
            setChangePasswordErrors(response.error);
            toast.error(response.message);
        }     

    } catch (error) {
        apiError(error);
    }

    // Stop the loading state
    loader.style.display = 'none';
  };
  // Change Password End

  return (    
        <AdminLayout>
            <Helmet><title>Profile - Digital CMS</title></Helmet>

            <div className="main-content app-content">

                <div className="container-fluid">

                    {/* <!-- Page Header --> */}
                    <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                        <h1 className="page-title fw-semibold fs-18 mb-0">Profile</h1>
                        <div className="ms-md-1 ms-0">
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Profile</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    {/* <!-- Page Header Close --> */}

{profileLoading ? (


<ProfileTabs />

) : (  
    
    <div className="row">
        <div className="col-xxl-4 col-xl-12">
            <div className="card custom-card overflow-hidden">
                <div className="card-body p-0">
                    <div className="d-sm-flex align-items-top p-4 border-bottom-0 main-profile-cover">
                        <div>
                            <span className="avatar avatar-xxl avatar-rounded online me-3">
                                {profilePic(profileData.user_first_name, profileData.user_last_name, profileData.user_image, '67px', '25px', user_image!=='' ? 'none' : 'block')}

                                <div className='d-flex justify-content-end' >
                                    <button type='button' className='btn-close profile-pic-remove' title='Remove Pic' 
                                    style={{display: user_image!=='' ? 'block' : 'none'}} onClick={(e) => setUserImage('')}
                                    ></button>
                                </div>
                                <img src={user_image ? URL.createObjectURL(user_image) : ``} alt="img"
                                style={{display: user_image!=='' ? 'block' : 'none'}} />

                                <button className="btn btn-link camera-btn" onClick={handleUserImageClick}
                                    style={{display: user_data.user_unique_id===user_unique_id ? 'block' : 'none'}}>
                                    <i className="bi bi-camera-fill"></i>
                                </button>

                                <input className='d-none' type='file' ref={userImageFileRef} onChange={handleUserImageChange} 
                                accept="image/png, image/jpeg, image/jpg" />
                            </span>
                            <div className='text-center me-3 mt-2'>
                                <button className='btn btn-link upload-btn' style={{display: user_image!=='' ? 'block' : 'none'}} title="Upload"
                                onClick={uploadProfilePicture}>
                                    <i className="bi bi-cloud-arrow-up"></i>
                                </button>
                            </div>
                        </div>
                        <div className="flex-fill main-profile-info">
                            <div className="d-flex align-items-center justify-content-between">
                                <h6 className="fw-semibold mb-1 text-fixed-white">{profileData.user_first_name} {profileData.user_last_name}</h6>
                            </div>
                            <p className="mb-1 text-muted text-fixed-white op-7">{profileData.user_job_title}</p>
                            <p className="fs-12 text-fixed-white mb-4 op-5">  
                                <span className="me-3">
                                    <i className="ri-cake-2-line me-1 align-middle"></i>{dateFormat(profileData.user_dob, "dd mmm")}
                                </span> 
                            </p>
                            {/* <div className="d-flex mb-0 d-none">
                                <div className="me-4">
                                    <p className="fw-bold fs-20 text-fixed-white text-shadow mb-0">113</p>
                                    <p className="mb-0 fs-11 op-5 text-fixed-white">Projects</p>
                                </div>
                                <div className="me-4">
                                    <p className="fw-bold fs-20 text-fixed-white text-shadow mb-0">12.2k</p>
                                    <p className="mb-0 fs-11 op-5 text-fixed-white">Followers</p>
                                </div>
                                <div className="me-4">
                                    <p className="fw-bold fs-20 text-fixed-white text-shadow mb-0">128</p>
                                    <p className="mb-0 fs-11 op-5 text-fixed-white">Following</p>
                                </div>
                            </div> */}
                        </div>
                    </div>  
                    <div className="p-4 border-bottom border-block-end-dashed">
                        <p className="fs-15 mb-2 me-4 fw-semibold">Contact Information :</p>
                        <div className="text-muted">
                            <p className="mb-2">
                                <span className="avatar avatar-sm avatar-rounded me-2 bg-light text-muted">
                                    <i className="ri-mail-line align-middle fs-14"></i>
                                </span>
                                {profileData.user_email}
                            </p>
                            <p className="mb-2">
                                <span className="avatar avatar-sm avatar-rounded me-2 bg-light text-muted">
                                    <i className="ri-phone-line align-middle fs-14"></i>
                                </span>
                                {profileData.user_mobile}
                            </p>
                            <p className="mb-0">
                                <span className="avatar avatar-sm avatar-rounded me-2 bg-light text-muted">
                                    <i className="ri-map-pin-line align-middle fs-14"></i>
                                </span>
                                {profileData.user_address}
                            </p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div className="col-xxl-8 col-xl-12">
            <div className="row">
                <div className="col-xl-12">
                    <div className="card custom-card">
                        <div className="card-body p-0">
                            
                            <div className="p-0">
                                <div className="tab-content" id="myTabContent">

                                    {/* <!--Profile Tab Content Start---> */}
                                    {user_data.user_unique_id === user_unique_id ? (
                                    <div className="tab-pane show active fade p-0 border-0" id="profile-tab-pane" role="tabpanel" 
                                        aria-labelledby="profile-tab" tabIndex="0">

                                        {/* <h4>Profile</h4> */}

                                        {/* <!--General Info Card Start---> */}
                                        <div className="card custom-card">
                                            <div className="card-header">
                                                <div className="card-title">
                                                    Profile
                                                </div>
                                            </div>
                                            <div className="card-body">

                                                <div className="row gy-3 mb-4">

                                                    <div className="col-xl-4">
                                                        <label className="form-label">Name: </label>
                                                        {/* <input type="text" className="form-control" placeholder="First Name"  readOnly={user_data.urole_permission !== '*'}
                                                        value={user_first_name} 
                                                        onChange={(e) => setUserFirstName(e.target.value)} /> */}

                                                        {profileData.user_first_name} {profileData.user_last_name}

                                                        {/* {genInfoerrors.user_first_name && <p style={{ color: 'red' }}>{genInfoerrors.user_first_name}</p>} */}
                                                    </div>

                                                    {/* <div className="col-xl-3">
                                                        <label className="form-label">Last Name : <span className="text-danger">*</span></label>
                                                        <input type="text" className="form-control" placeholder="Last Name" readOnly={user_data.urole_permission !== '*'}
                                                        value={user_last_name} onChange={(e) => setUserLastName(e.target.value)} />

                                                        {genInfoerrors.user_last_name && <p style={{ color: 'red' }}>{genInfoerrors.user_last_name}</p>}
                                                    </div> */}

                                                    <div className="col-xl-4">
                                                        <label className="form-label">Date of Birth: </label>

                                                        {formatDate(profileData.user_dob)}

                                                        {/* <DatePicker className="form-control" placeholderText="DD-MM-YYYY" readOnly={user_data.urole_permission !== '*'}
                                                            selected={user_dob} onSelect={setUserDob} onChange={setUserDob} dateFormat="dd-MM-yyyy"/>

                                                        {genInfoerrors.user_dob && <p style={{ color: 'red' }}>{genInfoerrors.user_dob}</p>} */}
                                                    </div>

                                                    <div className="col-xl-4">
                                                        <label className="form-label">Gender: </label>
                                                        
                                                        {capitalize(profileData.user_gender)}

                                                      {/* <label className="radio-inline">
                                                        <input type="radio" name="user_gender" value="male" checked={user_gender==='male' ? 'checked': ''} disabled={user_data.urole_permission !== '*'}
                                                        onChange={(e) => setUserGender(e.target.value)}/>&nbsp;Male&nbsp;&nbsp;
                                                      </label>

                                                      <label className="radio-inline">
                                                        <input type="radio" name="user_gender" value="female" checked={user_gender==='female' ? 'checked': ''} disabled={user_data.urole_permission !== '*'}
                                                        onChange={(e) => setUserGender(e.target.value)} />&nbsp;Female&nbsp;&nbsp;
                                                      </label>

                                                      <label className="radio-inline">
                                                        <input type="radio" name="user_gender" value="other" checked={user_gender==='other' ? 'checked': ''} disabled={user_data.urole_permission !== '*'}
                                                        onChange={(e) => setUserGender(e.target.value)} />&nbsp;Other
                                                      </label>

                                                      {genInfoerrors.user_gender && <p style={{ color: 'red' }}>{genInfoerrors.user_gender}</p>} */}
                                                    </div>

                                                </div>

                                                <div className="row gy-3 mb-3">

                                                    <div className="col-xl-4">
                                                        <label htmlFor="designationId" className="form-label">Designation:</label>
                                                        {/* <select className="form-control" onChange={(e) => setDesignationId(e.target.value)}>
                                                            <option value="">- Select Designation -</option>
                                                            {designations?.map((row) => (
                                                                <option key={row._designation_id} value={row._designation_id} selected={designationId === row._designation_id}>
                                                                    {row.designation_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {genInfoerrors.user_designation_id && <p style={{ color: 'red' }}>{genInfoerrors.user_designation_id}</p>} */}

                                                        {profileData.designation_name}
                                                    </div>

                                                    <div className="col-xl-4">
                                                        <label htmlFor="designationId" className="form-label">Manager:</label>
                                                        {/* <select className="form-control" onChange={(e) => setManagerId(e.target.value)}>
                                                            <option value="">- Select Manager -</option>
                                                            {managers?.map((row) => (
                                                                <option key={row._user_id} value={row._user_id} selected={managerId === row._user_id}>
                                                                    {row.user_first_name} {row.user_last_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {genInfoerrors.user_manager_id && <p style={{ color: 'red' }}>{genInfoerrors.user_manager_id}</p>} */}

                                                        {profileData.manager_name}
                                                    </div>

                                                    <div className="col-xl-4">
                                                        <label htmlFor='user_start_date' className="form-label">Start Date:</label>

                                                        {formatDate(profileData.user_start_date)}

                                                        {/* <DatePicker className="form-control" placeholderText="DD-MM-YYYY"
                                                            selected={startDate} onSelect={setStartDate} onChange={setStartDate} dateFormat="dd-MM-yyyy"/>

                                                        {genInfoerrors.user_start_date && <p style={{ color: 'red' }}>{genInfoerrors.user_start_date}</p>} */}
                                                    </div>
                                                </div>   

                                                <div className="row gy-3 mt-3">

                                                    <div className="col-xl-4">
                                                        <label htmlFor="input-label" className="form-label">Email: <span className="text-danger">*</span></label>
                                                        <input type="text" className="form-control" placeholder="Email address" 
                                                        // readOnly={user_data.urole_permission !== '*'}
                                                        value={userEmail} onChange={(e) => setUserEmail(e.target.value)}/>

                                                        {genInfoerrors.user_email && <p style={{ color: 'red' }}>{genInfoerrors.user_email}</p>}
                                                    </div>

                                                    <div className="col-xl-4">
                                                        <label htmlFor="input-label" className="form-label">Mobile: <span className="text-danger">*</span></label>
                                                        <input type="text" className="form-control" placeholder="Mobile number" 
                                                        // readOnly={user_data.urole_permission !== '*'}
                                                        value={userMobile} onChange={(e) => setUserMobile(e.target.value)}/>

                                                        {genInfoerrors.user_mobile && <p style={{ color: 'red' }}>{genInfoerrors.user_mobile}</p>}
                                                    </div>

                                                    <div className="col-xl-4">
                                                        <label htmlFor="input-label" className="form-label">Address: <span className="text-danger">*</span></label>
                                                        <textarea className="form-control" placeholder="Address" rows="3" value={userAddress}
                                                        // readOnly={user_data.urole_permission !== '*'}
                                                        onChange={(e) => setUserAddress(e.target.value)}></textarea>

                                                        {genInfoerrors.user_address && <p style={{ color: 'red' }}>{genInfoerrors.user_address}</p>}
                                                    </div>
                                                </div>

                                                {/* {user_data.urole_permission==='*' ? (  */}
                                                    <br />
                                                    <button className="btn btn-primary-light btn-wave ms-auto float-end" onClick={updateGeneralInfo}>Update</button>
                                                {/* ):('')} */}
                                            </div>  
                                        </div>
                                        {/* <!--General Info Card End---> */}

                                        {/* <!--Change Password Card Start---> */}
                                        {user_data.user_unique_id===user_unique_id ? (
                                        <div className="card custom-card">
                                            <div className="card-header">
                                                <div className="card-title">
                                                    Change Password
                                                </div>
                                            </div>
                                            <div className="card-body">

                                                <div className="row gy-3">

                                                    <div className="col-xl-4">
                                                        <label className="form-label">Current Passsword : <span className="text-danger">*</span></label>
                                                        <input type="text" className="form-control" placeholder="Current Passsword" value={current_password} onChange={(e) => setCurrentPassword(e.target.value)} />

                                                        {changePasswordErrors.current_password && <p style={{ color: 'red' }}>{changePasswordErrors.current_password}</p>}
                                                    </div>

                                                    <div className="col-xl-4">
                                                        <label className="form-label">New Passsword : <span className="text-danger">*</span></label>
                                                        <input type="text" className="form-control" placeholder="New Passsword" value={new_password} onChange={(e) => setNewPassword(e.target.value)} />

                                                        {changePasswordErrors.new_password && <p style={{ color: 'red' }}>{changePasswordErrors.new_password}</p>}
                                                    </div>

                                                    <div className="col-xl-4">
                                                        <label className="form-label">Confirm Passsword : <span className="text-danger">*</span></label>
                                                        <input type="text" className="form-control" placeholder="Confirm Passsword" value={confirm_password} onChange={(e) => setConfirmPassword(e.target.value)} />

                                                        {changePasswordErrors.confirm_password && <p style={{ color: 'red' }}>{changePasswordErrors.confirm_password}</p>}
                                                    </div>

                                                </div>    

                                            </div>  

                                            <div className="card-footer">
                                                <button className="btn btn-primary-light btn-wave ms-auto float-end" onClick={changePassword}>Update</button>
                                            </div>   
                                        </div> 
                                        ):('')}
                                        {/* <!--Change Password Card End--->    */}
                                        
                                    </div>
                                    ):('')}
                                    {/* <!--Profile Tab Content End---> */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    
    )} 

                </div>
            </div>  
            <Helmet></Helmet>
        </AdminLayout>
  )
}

export default Profile
